define('GameDayCore/GDModel/storage/GumboItemModelCache',['require','exports','module','gumbo-js-client-lib/Gumbo'],function(require, exports, module){
	var GumboFormat = require("gumbo-js-client-lib/Gumbo");

	function GumboItemModelCache($gameID, $timestamp) {
		this.gameID = $gameID;
		this.timestamp = $timestamp;
	}

	GumboItemModelCache.prototype = {
		gameID: null,
		timestamp: null,
		gameData: new GumboFormat(),
		resetGameData: new GumboFormat()
	};

	return GumboItemModelCache;
});
